<template>
  <v-dialog
    v-model="getModalCancelarNfce"
    persistent
    max-width="720px"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title>Cencelar NFC-e</v-card-title>
      <v-form class="px-3" ref="formCancelamentoNfce">
        <v-card-text>
          <v-layout row wrap>
            <v-text-field
              class="mr-2 ml-2"
              label="Justificativa"
              v-model="dadosCancelamento.justificativa"
              outlined
              dense
              :rules="rules.justificativa"
            ></v-text-field>
          </v-layout>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <v-btn
          color="default"
          outlined
          dense
          @click="setModalCancelarNfce(false)"
          :loading="$store.getters.getOverlay"
          >Fechar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="success" outlined dense @click="_cancelarNfce()"
        :loading="$store.getters.getOverlay"
          >Cancelar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      dadosCancelamento: {
        justificativa: "",
      },
      rules: {
        justificativa: [
          (v) => !!v || "Campo obrigatório.",
          (v) =>
            (v && v.length >= 15) || "Deve conter no mínimo 15 caracteres.",
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["getVenda", "getModalCancelarNfce"]),
  },
  methods: {
    ...mapActions(["setModalCancelarNfce", "cancelarNfce"]),
    _cancelarNfce() {
      if (this.$refs.formCancelamentoNfce.validate()) {
        this.cancelarNfce({
          venda_id: this.getVenda.id,
          justificativa: this.dadosCancelamento.justificativa,
        }).then(() => {
          this.dadosCancelamento.justificativa = "";
        });
      }
    },
  },
  created() {},
};
</script>